import { Platform } from "react-native";

export type PdfComponentType = "PdfViewer" | "ScreenCard";

/**
 * The PDF component has not the same behavior on android and ios
 * on Android, the scroll must be enabled on the pdf viewer but not on the screen card holding the pdf viewer
 * on iOS, the scroll must be enabled on the screen card holding the pdf viewer but not on the pdf viewer itself
 * on the web we don't care about the scroll behavior as it is never used ( iframe )
 * @param component
 */
export const isScrollEnabledForPdfComponent = (component: PdfComponentType): boolean => {
    if (Platform.OS === "android") {
        if (component === "PdfViewer") {
            return true;
        }
        return false;
    } else if (Platform.OS === "ios") {
        if (component === "PdfViewer") {
            return false;
        }
        return true;
    } else {
        // web , don't care it is never used
        if (component === "PdfViewer") {
            return true;
        }
        return false;
    }
};
